// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__T482t"};